// SPDX-FileCopyrightText: 2024-2025 John Livingston <https://www.john-livingston.fr/>
//
// SPDX-License-Identifier: AGPL-3.0-only

export const XMLNS_MAM_SEARCH = 'urn:xmpp:mam:2#x-search'
